import * as React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const DANGER = 'bg-danger-subtle text-danger-ink border-danger-solid/30 [&>svg]:text-danger-ink'

/**
 * Banner recipe. `destructive` is an alias of `danger` for the alias release.
 * Banners take the control radius (rulebook R13): the 20px surface radius
 * read as a pill on a one-line banner.
 */
const alertVariants = cva(
  'relative w-full rounded-control border px-4 py-3 text-body [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg~*]:pl-7',
  {
    variants: {
      variant: {
        default: 'bg-surface text-ink border-line [&>svg]:text-ink-2',
        info: 'bg-info-subtle text-info-ink border-info-solid/30 [&>svg]:text-info-ink',
        success:
          'bg-success-subtle text-success-ink border-success-solid/30 [&>svg]:text-success-ink',
        warning:
          'bg-warning-subtle text-warning-ink border-warning-solid/30 [&>svg]:text-warning-ink',
        danger: DANGER,
        destructive: DANGER,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
))
Alert.displayName = 'Alert'

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5 ref={ref} className={cn('mb-1 font-medium', className)} {...props} />
))
AlertTitle.displayName = 'AlertTitle'

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-body [&_p]:leading-relaxed', className)} {...props} />
))
AlertDescription.displayName = 'AlertDescription'

export { Alert, AlertTitle, AlertDescription }
